export default __webpack_public_path__ + "static/printer_b.358d3b6eb8f4f1467e9816936243c891.png";